<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">订单管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">商品管理</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <a-button @click="addstatus" type="primary">添加商品</a-button>
                <a-button type="danger" :disabled="disabled" @click="delusers">删除商品</a-button>
            </div>
            <!-- 搜索 --> 

            <div class="right">
                <a-input-search
                    placeholder="请输入"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                </a-input-search>
            </div>
        </div>
        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table :row-selection="{ onChange: onSelectChange}" rowKey="smid" :scroll="{x: 1100}" :pagination="pageshow" :columns="columns" :data-source="data">
                    
                    <span slot="action" slot-scope="text,record" class="operate">
                        <a href="javascript:;" @click="edituser(record.smid)"><a-icon type="edit" /> 编辑</a>
                        <a href="javascript:;" @click="deluser(record.smid)"><a-icon type="delete" /> 删除</a>
                    </span>

                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>


                    <span slot="video" >
                        <!-- <video :src="text"></video> -->
                    </span>

                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>

         <!-- 添加商品 -->
        <a-modal
        title="添加商品"
        :visible="addvisible"
        cancelText="取消"
        okText="确认"
        @ok="addhandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">

                <a-form-item label="商品名称">
                    <a-input v-model="title" placeholder="请输入商品名称" v-decorator="['商品名称', { rules: [{ required: true, message: '请输入商品名称' }] }]"/>
                </a-form-item>
                <a-form-item label="商品价格">
                    <a-input v-model="price" placeholder="请输入商品价格"/>
                </a-form-item>
            </a-form>
        </a-modal>

        <!-- 编辑商品 -->
        <a-modal
        title="编辑商品"
        :visible="editvisible"
        cancelText="取消"
        okText="确认"
        @ok="edithandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">

                 <a-form-item label="商品名称">
                    <a-input v-model="editinfo.title" placeholder="请输入商品名称" />
                </a-form-item>
                <a-form-item label="商品价格">
                    <a-input v-model="editinfo.price" placeholder="请输入商品价格"/>
                </a-form-item>
            </a-form>
        </a-modal>

    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { Modal } from 'ant-design-vue';
const columns = [
    {title: 'ID',dataIndex: 'smid',key: 'smid'},
    {title: '商品名称',dataIndex: 'title',key: 'title'},
    {title: '商品价格',dataIndex: 'price',key: 'price'},
    // {title: '排序',dataIndex: 'sort',key: 'sort'},
    {title: '添加时间',dataIndex: 'addtime',key: 'addtime',scopedSlots: { customRender: 'date' }},
    {title: '操作',key: 'action',scopedSlots: { customRender: 'action' }},
]
export default {
     filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      }
    },
    data(){
        return{
            locale,
            form: this.$form.createForm(this, { name: 'coordinated' }),

            columns,
            data:[],
            tablespinning:true,
            pageSizeOptions:['10','20','30','40','100','200'],
            pagination:{},
            size:10,
            totalpage:"",
            pageshow:false,
            currentpagination:"",
            addvisible:false,
            editvisible:false,

            title:"",
            price:"",

            editinfo:"",
            editid:"",
            disabled:true,
            delids:"",
            true:true,
            false:false,

            searchtext:""
        }
    },
    mounted(){
        this.fetch()
    },
    methods:{
        handleCancel(){
            this.editvisible=false
            this.addvisible=false
        },

         // 删除
        onSelectChange(selectedRowKeys){
            if(selectedRowKeys.length>0){
                this.disabled=false
            }else{
                this.disabled=true
            }
            this.delids=selectedRowKeys
        },
        delusers(){
            var id=this.delids.join(",")
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(id)
                },
                onCancel() {

                },
            });
        },
        deluser(id){
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(id)
                },
                onCancel() {

                },
            });
        },
        handok(id){
            this.$axios.post('/api/order/delgoodssetmeal',{
                smids:id
            },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.disabled=true
                    this.$message.success('删除成功');
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        // 添加商品
        addstatus(){
            this.addvisible=true
        },
        addhandleOk(){
            this.$axios.post('/api/order/addgoodssetmeal',{
                title:this.title,
                price:this.price
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.title=""
                    this.price=""
                    this.addvisible=false
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

        // 编辑商品
        edituser(id){
            this.editid=id
            this.$axios.post('/api/order/goodssetmealpage',{
                smid:id
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editvisible=true
                    this.editinfo=res.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        edithandleOk(){
            this.$axios.post('/api/order/editgoodssetmeal',{
                smid:this.editid,
                title:this.editinfo.title,
                price:this.editinfo.price
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editvisible=true
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

         // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },
        // 搜索
        onSearch(){
            this.fetch()
        },
        // 数据
        fetch(params = {}){
            this.$axios.post('/api/order/goodssetmeallist',{
                pagesize: this.size,
                page:this.currentpage,
                search:this.searchtext
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    // const pagination = { ...this.pagination };
                    // pagination.total = res.data.data.total;
                    // pagination.pageSize=this.size
                    // var data=res.data.data.data
                    // for(var i in data){
                    //     if(data[i].status==-1){
                    //         data[i].status=false
                    //     }else{
                    //         data[i].status=true
                    //     }
                    // }
                    this.data=res.data.data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/order/goodslist.vue